import React, { Fragment } from "react";
import { Badge, Form } from "react-bootstrap";
import { THindcastOption } from "../../../../../api/endpoints/SubsetOption";
import { formatBoolean } from "../../../../../utils/Format";
import { Radio } from "../../../../Inputs/Radio";
import ExternalLink from "../../../../Navigation/Links/ExternalLink";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import HindcastSelector from "../../../HindcastSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

const decodeBoolean = (value: string) => value === 'true';

interface Props extends FormikProductFormField {
  spec: THindcastOption;
  isSelected: boolean;
  onToggle: (selected: boolean) => void;
}

const HindcastField = (props: Props) => {
  const { formik, spec, onToggle, isSelected } = props;

  return (
    <Form.Group controlId="hindcast" className="hindcast-field-group">
      <Form.Label>Hindcast</Form.Label>

      <div className="hindcast-radio">
        {
          [true, false].map(option => {
            return <Radio
              value={option.toString()}
              key={option.toString()}
              label={formatBoolean(option)}
              name="hindcast-selected"
              onChange={value => onToggle(decodeBoolean(value))}
              checked={option === isSelected}
            />
          })}
      </div>

      <Footnote
        text={
          <Fragment>
            Hindcasts/re-forecasts can be used for calibration.
            See this <ExternalLink url="https://confluence.ecmwf.int/display/FCST/Sub-seasonal+range+re-forecasts+configurations+changes">page</ExternalLink> for more information.
          </Fragment>
        }
      />

      {
        isSelected &&
        <Fragment>
          <HindcastSelector
            values={formik.values.hindcast ?? []}
            spec={spec}
            onChange={value => formik.setFieldValue('hindcast', value)}
          />

          <FormError
            message={formik.errors.hindcast as TFormErrorMessage}
            when={formik.touched.hindcast && Boolean(formik.errors.hindcast)}
          />

          <Footnote text={spec.footnote} />
        </Fragment>
      }
    </Form.Group>
  );
}

export default HindcastField;
